import {
  siFacebook,
  siInstagram,
  siTelegram,
  siTiktok,
  siWhatsapp,
  siX,
  siYoutube,
  type SimpleIcon,
} from 'simple-icons';

/** Curated social/brand icons for customer site templates (Simple Icons, CC0). */
export const SITE_SOCIAL_ICONS = {
  facebook: siFacebook,
  instagram: siInstagram,
  telegram: siTelegram,
  tiktok: siTiktok,
  whatsapp: siWhatsapp,
  x: siX,
  youtube: siYoutube,
} as const;

export type SiteSocialNetwork = keyof typeof SITE_SOCIAL_ICONS;

export type { SimpleIcon };

export function resolveSiteSocialIcon(
  networkOrIcon: SiteSocialNetwork | SimpleIcon,
): SimpleIcon {
  if (typeof networkOrIcon === 'string') {
    return SITE_SOCIAL_ICONS[networkOrIcon];
  }
  return networkOrIcon;
}
